jQuery(document).ready(function ($) {
  // console.log('sdfghsdf');
  $('.wp-block-details').first().attr('open', 'open');

  $('.wp-block-details summary').click(function () {
    // console.log('i click');

    // Get the parent details element.
    var currentDetails = $(this).closest('.wp-block-details');

    // Close all other details elements within the same container.
    $('.wp-block-details').not(currentDetails).removeAttr('open');

    // Toggle the 'open' attribute on the clicked details element.
    //   if (currentDetails.attr('open')) {
    //     currentDetails.removeAttr('open');
    //   } else {
    //     currentDetails.attr('open', 'open');
    //   }
  });
});